/* @flow */
import type { LiferayError, User, ReduxState, Action } from 'types';

// ===========================
//   STATE TYPE
// ===========================
export type AuthState = {
  user: ?User,
  isLoggingIn: boolean,
  isLoggingOut: boolean,
  error: ?LiferayError,
};

// ===========================
//   INITIAL STATE
// ===========================
export const initialState: AuthState = {
  user: null,
  isLoggingIn: false,
  isLoggingOut: false,
  error: null,
};

// ===========================
//   REDUCER
// ===========================
export default (state: AuthState = initialState, action: Action): AuthState => {
  switch (action.type) {
    case 'INITIALIZE_APP_SUCCESS':
      return { ...state, user: action.payload };

    case 'LOGIN_REQUEST':
      return { ...state, isLoggingIn: true, error: null };
    case 'LOGIN_SUCCESS':
      return { ...state, isLoggingIn: false, user: action.payload };
    case 'LOGIN_FAILURE':
      return { ...state, isLoggingIn: false, error: action.payload };

    case 'LOGOUT_REQUEST':
      return { ...state, isLoggingOut: true, error: null };
    case 'LOGOUT_SUCCESS':
      return { ...state, isLoggingOut: false, user: null };

    default:
      return state;
  }
};

// ===========================
//   SELECTORS
// ===========================
export const getIsAuthenticated = (state: ReduxState): boolean => {
  return state.auth.user !== null && state.auth.user !== undefined;
};

export const getIsLoading = (state: ReduxState): boolean => {
  return state.auth.isLoggingIn || state.auth.isLoggingOut;
};
